import { TooltipProvider } from "@aurumiq/ui/components/tooltip";
import { type QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode, useState } from "react";
import { AuthProvider } from "@/auth/auth-provider";
import { makeQueryClient } from "@/lib/query-client";
import { ApiTokenBridge } from "./api-token-bridge";

export function Providers({
  children,
  queryClient,
}: {
  children: ReactNode;
  queryClient?: QueryClient;
}) {
  const [qc] = useState(() => queryClient ?? makeQueryClient());
  return (
    <QueryClientProvider client={qc}>
      <AuthProvider>
        {/* Registers the token getter for every route (including full-screen ones outside Shell). */}
        <ApiTokenBridge />
        <TooltipProvider>{children}</TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
